import React from "react";
import { Route, Redirect } from "react-router-dom";
// import useStoreShopifyAuthData from '../screens/shopify/hooks/useStoreAuthData';
import { isAuthenticated } from "../store/action/auth";

const PublicRoute = ({ component: Component, ...rest }) => {
  // useStoreShopifyAuthData();
  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated()) {
          if (arrayOfPaths.includes(props.location.pathname)) {
            return <Component {...props} />;
          }
          return <Redirect to={{ pathname: "/overview", state: { from: props.location } }} />;
        }
        return <Component {...props} />;
      }}
    />
  );
};
export default PublicRoute;

const arrayOfPaths = [];
